module.exports = __webpack_public_path__ + "static/media/ws.2d920c55.svg";